import { getAITutorModalityAttachmentPattern } from "Utils/AIUtils";

// Regex pattern constants
export const REGEX_PATTERNS = {
  // List patterns
  LIST_ITEM: /^(\s*)(-|\*|\d+\.)\s+/,
  LIST_ITEM_WITH_BRACKET_NUMBER: /^(\s*)(-|\*|\d+\.)\s+(?:\[(\d+)\])?\s*(.*)/,
  LIST_ITEM_WITH_PARENTHESIS_NUMBER: /^(\s*)(-|\*|\d+\.)\s+(.*?)(?:\((\d+)\))?(.*)/,
  LIST_ITEM_WITH_TEXT_NUMBER: /^(\s*)(-|\*|\d+\.)\s+(.*?)(\d+)?\s*(.*)/,
  // Flexible number pattern - will find numbers in different formats anywhere in the line
  FLEXIBLE_NUMBER_PATTERN: /^(\s*)(-|\*|\d+\.)\s+(.*?)(?:\[(\d+)\]|\((\d+)\)|(\d+))(?:$|\s+(.*))/,

  // Indentation pattern
  INDENTATION: /^(\s*)/,

  // Number formatting patterns
  LARGE_NUMBERS: /\b\d{7,}\b/g,
  BRACKET_NUMBERS: /\[\d+\]/g,
  PARENTHESIS_NUMBERS: /\(\d+\)/g,

  // Other patterns
  LIST_VIEW_PATTERN: /^\s*(-|\d+\.?)(\s+)/,
  ACCORDION_VIEW_PATTERN: /\s*(\*\s*)?\[([A-Z0-9_ ]+)\](?!\()/i,
  FIELD_VIEW_PATTERN: /^```/,
  MARKDOWN_TABLE_PATTERN: /^\s*\|.*\|$/,
  HTML_TAG_PATTERN: /<\/?[a-z][\s\S]*>/i,
  BANNER_IMAGE_TAG_PATTERN: /<banner_image>[\s\S]*?<\/banner_image>/i,
  ATTACHMENT_PATTERN: new RegExp(`^${getAITutorModalityAttachmentPattern()}$`),
  BANNER_LOADER_PATTERN: /^%%%ANNOUNCEMENT_BANNER%%%$/m,
};
